<template>
    <button
        @click="setSelectedOption"
        type="button"
        :disabled="!isEnabled"
        :style="{ backgroundImage: `url(${optionImage})` }"
        class="relative overflow-hidden shadow-inner p-1 pt-4 w-[120px] h-[200px] flex flex-col items-center bg-dust bg-cover cz3-fancy-button"
    >
        <span class="my-2 mx-4 h-7 font-freizeit text-base !leading-none">
            {{ optionDescription.name }}
        </span>

        <span
            v-if="optionDescription.description"
            class="font-grotesk text-xs !leading-tight font-light"
        >
            {{ optionDescription.description }}
        </span>

        <span
            v-if="isSelectedOption"
            class="absolute inset-0 border-2 border-shine w-full h-full"
        ></span>
    </button>
</template>

<script>
    import allStores from '../stores/all';

    import * as constants from '../constants';

    export default {
        mixins: [allStores],

        props: {
            groupName: {
                type: String,
                required: true,
            },

            optionData: {
                type: Object,
                required: true,
            },

            isEnabled: {
                type: Boolean,
                required: true,
            },
        },

        computed: {
            isMobile() {
                return this.appStore.isMobile;
            },

            currentStep() {
                return this.appStore.currentStep;
            },

            isSelectedOption() {
                return this.customizerStore.viewController.isSelected(this.optionDescription.code);
            },

            optionDescription() {
                return this.optionData.description[0];
            },

            optionImage() {
                return this.optionData.custom.image;
            },
        },

        methods: {
            setSelectedOption() {
                const delay = this.isMobile ? 300 : 0;

                this.customizerStore.viewController.updateComponent(this.groupName, this.optionData.code);

                this.updateBottleLabel();

                setTimeout(() => {
                    this.loadNextStep();
                }, delay);
            },

            updateBottleLabel() {
                if (this.appStore.isEnabledStep(constants.STEP_SELECT_WHISKEY)) {
                    this.customizerStore.setCaptionLabel();
                    this.customizerStore.setWhiskeyLabel();
                }
                if (this.appStore.isEnabledStep(constants.STEP_SELECT_PROOF)) {
                    this.customizerStore.setProofLabels();
                    this.customizerStore.setAlcoholLabel();
                }
                if (this.appStore.isEnabledStep(constants.STEP_SELECT_SPIRE)) {
                    this.customizerStore.setSpireLabel();
                    this.customizerStore.setFireLabel();
                    this.customizerStore.setCaptionLabel();
                    this.customizerStore.setDescription1Label();
                    this.customizerStore.setDescription2Label();
                }
                if (this.appStore.isEnabledStep(constants.STEP_SELECT_INFUSION)) {
                    this.customizerStore.setDescription1Label();
                    this.customizerStore.setDescription2Label();
                    this.customizerStore.setInfusionLabel();
                }
            },

            loadNextStep() {
                if (this.currentStep === constants.STEP_SELECT_INFUSION && !this.isMobile) {
                    return;
                }

                this.appStore.loadNextStep(this.groupName);
            },
        },
    };
</script>

<style scoped>
    .cz3-fancy-button:hover {
        @apply transition-all duration-200;
    }
    .cz3-fancy-button:after {
        @apply absolute top-0 w-full h-full pointer-events-none opacity-0;

        content: "";
        background-image: radial-gradient(circle, #fff 10%, transparent 10%);
        transform: scale(10, 10);
        transition: transform 0.3s, opacity 1s;
    }
    .cz3-fancy-button:active:after {
        transform: scale(0, 0);
        opacity: 0.15;
        transition: 0s;
    }
</style>
